export const GET_LENGTH_MOVIE = "GET_LENGTH_MOVIE"
export const GET_LENGTH_CLIENT = "GET_LENGTH_CLIENT"